<script>
	import {
		DataTable,
		Toolbar,
		ToolbarContent,
		ToolbarSearch,
		StructuredList,
		StructuredListHead,
		StructuredListRow,
		StructuredListCell,
		StructuredListBody,
		Link,
		OutboundLink,
	} from "carbon-components-svelte";
	import { onMount } from 'svelte'
	import { words } from 'lodash'
	import Papa from 'papaparse'
	$: data = [];
	let error = {};
	let fullData = [];
	let search = "";

	onMount(async () => {
		Papa.parse('https://docs.google.com/spreadsheets/d/1L-3LKM_7cA4MP5FvPr--iNIFNh8hmc_s18OnPRPWqQ4/pub?output=csv', {
			download: true,
			header: true,
			complete: function (results) {
				fullData = data = results.data.sort((a, b) => { return a['Software Name'] >= b['Software Name'] ? 1 : -1 }).map((entry, index) => {
					return { id: index, ...entry }
				})
				console.log(data)
			},
			error: function (err) {
				error = err
				console.log(err)
			}
		})
	})

	let handleChange = event => {
		search = event.target.value;
		console.log(search)
		filterServices();
	}


	let filterServices = () => {
		let temp = [...fullData]
		temp = temp.filter(item => {
			let results = words(search).map(word => {
				let test = false
				if (item['Description'].toLowerCase().includes(word))
					test = true
				if (item['Software Name'].toLowerCase().includes(word)) test = true
				item['Software Company'].split(',').map(tag => {
					if (tag.toLowerCase().includes(word)) test = true
				})
				item['Keywords'].split(',').map(tag => {
					if (tag.toLowerCase().includes(word)) test = true
				})
				return test
			})
			return results.every(value => value) ? true : false
		})
		console.log(temp)
		data = [...temp]
	}

	let sortAnnounce = event => {
		let assertion = document.getElementById("assert");
		event.detail.sortDirection === 'none' ? assertion.innerText = "Columns are no longer sorted" : assertion.innerText = "Column " + event.detail.header.value + " sorted in " + event.detail.sortDirection + " order";
	}

	let header = [
		{ key: "Software Name", value: "Software Name" },
		{ key: "Software Company", value: "Software Company" },
		{ key: "Building", value: "Building" },
		{ key: "Room", value: "Room" },
		{ key: "Contact", value: "Contact" },
		{ key: "Categories", value: "Categories" }]

</script>

<main>
	{#await data}
	<p>...waiting</p>
	{:then data}
	<DataTable sortable expandable title="Student Software List"
		description="Click on the dropdown arrow for a piece of software to see more information about how to access it. You may see multiple entries for the same piece of software; this means it is available in multiple locations and may have different restrictions based on location."
		headers={header} rows={data} on:click:header={sortAnnounce}>
		<Toolbar>
			<ToolbarContent>
				<ToolbarSearch expanded persistent on:input={handleChange} value={search} />
			</ToolbarContent>
		</Toolbar>
		<div slot="expanded-row" let:row>
			<pre>
					<StructuredList>
						<StructuredListHead>
							<StructuredListRow head>
								<StructuredListCell head>Description</StructuredListCell>
								<StructuredListCell head>Restrictions</StructuredListCell>
								<StructuredListCell head>Number of Seats Available</StructuredListCell>
								<StructuredListCell head>Operating System</StructuredListCell>
							</StructuredListRow>
						</StructuredListHead>
						<StructuredListBody>
							<StructuredListRow>
								<StructuredListCell>{row.Description}</StructuredListCell>
								<StructuredListCell>{row.Restrictions}</StructuredListCell>
								<StructuredListCell>{row["Number of Computers with Software Available"]}</StructuredListCell>
								<StructuredListCell>{row["Type of Computer Software is Available On"]}</StructuredListCell>
							</StructuredListRow>
						</StructuredListBody>
					</StructuredList>
		    </pre>
		</div>
		<span slot="cell" let:row let:cell>
			{#if cell.key === 'Software Name'}
			<Link inline href={row['Software Webpage']} target="_blank">
			{cell.value}
			</Link>
			{:else if cell.key === 'Room'}
			<Link inline href={row['Link for More Information']} target="_blank">
			{cell.value}
			</Link>
			{:else if cell.key === 'Building'}
			<Link inline href={row['Link to Info/Directions to the Building']} target="_blank">
			{cell.value}
			</Link>
			{:else if cell.key === 'Contact'}
			<Link inline href="mailto:{row['Contact']}" target="_blank">
			{cell.value}
			</Link>
			{:else}{cell.value}{/if}
		</span>
	</DataTable>
	<div id="assert" aria-live="assertive"></div>
	{:catch error}
	<p style="color: red">{error.message}</p>
	{/await}
</main>
<div data-iframe-height></div>

<style type="text/scss">
	.vt-th {
		text-transform: uppercase;
		background-color: #faf9fa;
		letter-spacing: 0.075em;
	}

	.vt-table {
		font-family: gineso-condensed, sans-serif;
		color: #000;
		font-size: 0.67em;
		line-height: 1.4;
		font-weight: 400;
	}
	#assert {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		white-space: nowrap;
		border: 0;
	}
</style>